export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

/** Muss zu `public/theme-init.js` passen. */
export const STORAGE_KEY = 'socialfy-theme';

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function parsePreference(raw: string | null): ThemePreference {
  return raw === 'light' || raw === 'dark' || raw === 'system' ? raw : 'system';
}

export function resolveTheme(
  preference: ThemePreference,
  systemPrefersDark: boolean,
): ResolvedTheme {
  if (preference === 'system') {
    return systemPrefersDark ? 'dark' : 'light';
  }
  return preference;
}

/** Liest die Einstellung; gesperrter Speicher (Privatmodus) führt zum Standard "system". */
export function readPreference(storage: StorageLike = window.localStorage): ThemePreference {
  try {
    return parsePreference(storage.getItem(STORAGE_KEY));
  } catch {
    return 'system';
  }
}

export function writePreference(
  preference: ThemePreference,
  storage: StorageLike = window.localStorage,
): void {
  try {
    storage.setItem(STORAGE_KEY, preference);
  } catch {
    // Speicher gesperrt: Einstellung gilt nur für diese Sitzung
  }
}

export function applyTheme(
  preference: ThemePreference,
  systemPrefersDark: boolean,
  root: HTMLElement = document.documentElement,
): void {
  root.classList.toggle('dark', resolveTheme(preference, systemPrefersDark) === 'dark');
}
